var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        "pix-generic-form__container": _vm.sectionLabel,
        "center-spinner": _vm.loading,
      },
    },
    [
      _vm.loading
        ? _c("i", { staticClass: "mdi mdi-spin mdi-loading mdi-spinner" })
        : [
            _vm.sectionLabel
              ? _c(
                  "div",
                  { staticClass: "pix-generic-form__container__header__title" },
                  [_c("span", [_vm._v(_vm._s(_vm.sectionLabel))])]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "pix-generic-table__content" }, [
              _c(
                "div",
                [
                  _vm.headerButtons && _vm.headerButtons.length
                    ? _vm._l(_vm.headerButtons, function (button) {
                        return _c(
                          "div",
                          {
                            key: button.RowId,
                            staticClass: "table__actions",
                            class: button.Format,
                          },
                          [
                            _c(
                              "span",
                              [
                                _c("pix-button", {
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      (_vm.allTheColumnsAreConfidential &&
                                        (_vm.shouldDisableActions ||
                                          _vm.shouldBlurConfidentialFields)),
                                    label: button.Label,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.fnCallBack(
                                        $event,
                                        button,
                                        null
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("table", { staticClass: "pix-generic-table" }, [
                    _c("thead", [
                      _c(
                        "tr",
                        [
                          _vm.showTotals && !_vm.readonly
                            ? _c("th", { staticClass: "border-0" })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.multiselect &&
                          _vm.showMultiColumn &&
                          !_vm.readonly
                            ? _c(
                                "th",
                                {
                                  staticClass:
                                    "text-center subtable-header-style",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.lstOfDatRows &&
                                            _vm.lstOfDatRows.length > 0,
                                          expression:
                                            "lstOfDatRows && lstOfDatRows.length > 0",
                                        },
                                      ],
                                      staticClass: "wPointer",
                                    },
                                    [
                                      !_vm.isAllRowSelected
                                        ? _c("span", {
                                            staticClass:
                                              "mdi mdi-checkbox-blank-outline",
                                            on: {
                                              click: function ($event) {
                                                return _vm.fnToggleAllSel()
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isAllRowSelected
                                        ? _c("span", {
                                            staticClass:
                                              "mdi mdi-checkbox-marked-outline",
                                            on: {
                                              click: function ($event) {
                                                return _vm.fnToggleAllSel()
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("sup", {}, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$n(_vm.selectedRows.length)
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasSubtable
                            ? _c("th", {
                                staticClass:
                                  "text-center subtable-header-style",
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.columnsToDisplay, function (column) {
                            return _c(
                              "th",
                              {
                                key: column.RowId,
                                class: {
                                  "bg-primary text-light background-color":
                                    column.sort !== "NOS",
                                  "subtable-header-style":
                                    column.sort === "NOS",
                                },
                                attrs: {
                                  "data-qa-id": `${column.DataQaId}-label`,
                                },
                              },
                              [
                                _vm.fnEvalCondition(column.Conditions) &&
                                _vm.fnIsVisible(column) &&
                                column.gtShown
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          class: {
                                            wPointer: column.CanSort === true,
                                          },
                                          on: {
                                            click: function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "left",
                                                  37,
                                                  $event.key,
                                                  ["Left", "ArrowLeft"]
                                                )
                                              )
                                                return null
                                              if (
                                                "button" in $event &&
                                                $event.button !== 0
                                              )
                                                return null
                                              $event.preventDefault()
                                              return _vm.fnSortBy(column)
                                            },
                                            contextmenu: function ($event) {
                                              $event.preventDefault()
                                              return _vm.fnShowColModal()
                                            },
                                          },
                                        },
                                        [
                                          _c("div", {}, [
                                            _vm.shouldShowUnorderedIcon(column)
                                              ? _c("span", {
                                                  staticClass: "mdi mdi-blank",
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.shouldShowUnorderedIcon(column)
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "up-down-icon",
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass:
                                                        "mdi mdi-menu-up",
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass:
                                                        "mdi mdi-menu-down",
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            column.sort === "DESC" &&
                                            column.CanSort === true
                                              ? _c("span", {
                                                  staticClass:
                                                    "mdi mdi-menu-down",
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            column.sort === "ASC" &&
                                            column.CanSort === true
                                              ? _c("span", {
                                                  staticClass:
                                                    "mdi mdi-menu-up",
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !column.IconHeader
                                              ? _c("span", [
                                                  _vm._v(_vm._s(column.Label)),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            column.IconHeader
                                              ? _c("span", {
                                                  class: column.IconHeader,
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.badgeColSortOrder(column) !== -1
                                              ? _c("sup", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.badgeColSortOrder(
                                                        column
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.lstOfDatRows, function (entry, index) {
                          return _c(
                            "tr",
                            {
                              key: `${index}-${entry.RowId}`,
                              class: {
                                "table-secondary": _vm.isRowSelected(entry),
                                "bg-info-row": _vm.applyInfoBackground,
                              },
                              attrs: {
                                id: `gtable-${_vm.tableId}-${index}`,
                                "data-uid": `gtable-${_vm.tableId}-${index}`,
                              },
                              on: {
                                mouseover: function ($event) {
                                  return _vm.fnMouseOver(index)
                                },
                                mouseleave: function ($event) {
                                  return _vm.fnMouseLeave(index)
                                },
                                click: function ($event) {
                                  return _vm.handleRowClick(entry)
                                },
                              },
                            },
                            [
                              _vm.showTotals && !_vm.readonly
                                ? _c("td", {
                                    staticClass: "border-0",
                                    attrs: {
                                      id: `gtable-${_vm.tableId}-${index}-show-totals`,
                                      "data-uid": `gtable-${_vm.tableId}-${index}-show-totals`,
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.multiselect &&
                              _vm.showMultiColumn &&
                              !_vm.readonly
                                ? _c(
                                    "td",
                                    {
                                      staticClass: "text-center align-middle",
                                      attrs: {
                                        id: `gtable-${_vm.tableId}-${index}-multiselect`,
                                        "data-uid": `gtable-${_vm.tableId}-${index}-multiselect`,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.fnRowClick(entry, index)
                                        },
                                        dblclick: function ($event) {
                                          return _vm.fnDoubleRowClick(
                                            entry,
                                            index
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "wPointer" }, [
                                        _c("span", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !_vm.isRowSelected(entry),
                                              expression:
                                                "!isRowSelected(entry)",
                                            },
                                          ],
                                          staticClass:
                                            "mdi mdi-checkbox-blank-outline",
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isRowSelected(entry),
                                              expression:
                                                "isRowSelected(entry)",
                                            },
                                          ],
                                          staticClass:
                                            "mdi mdi-checkbox-marked-outline",
                                        }),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasSubtable
                                ? _c(
                                    "td",
                                    {
                                      staticClass: "text-center align-middle",
                                      attrs: {
                                        id: `gtable-${_vm.tableId}-${index}-has-subtable`,
                                        "data-uid": `gtable-${_vm.tableId}-${index}-has-subtable`,
                                      },
                                      on: {
                                        click: function ($event) {
                                          entry.collapsed = !entry.collapsed
                                        },
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "wPointer" }, [
                                        _c("span", {
                                          class: `mdi mdi-chevron-${
                                            entry.collapsed ? "right" : "down"
                                          }`,
                                        }),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(
                                _vm.columnsToDisplay,
                                function (col, indexCol) {
                                  return _c(
                                    "td",
                                    {
                                      key: col.RowId,
                                      staticClass: "align-middle",
                                      attrs: {
                                        id: `gtable-${_vm.tableId}-${index}-${indexCol}`,
                                        "data-uid": `gtable-${_vm.tableId}-${index}-${indexCol}`,
                                      },
                                    },
                                    [
                                      _vm.fnEvalCondition(col.Conditions) &&
                                      _vm.fnIsVisible(col) &&
                                      col.gtShown
                                        ? [
                                            _vm.shouldBlur(col)
                                              ? [_c("pix-blurred-field")]
                                              : [
                                                  col.IsEditable &&
                                                  !_vm.readonly
                                                    ? [
                                                        col.FieldControlType ===
                                                        "select"
                                                          ? _c("pix-select", {
                                                              attrs: {
                                                                id: `gtable-${_vm.tableId}-${index}-${indexCol}-select`,
                                                                "data-qa-id": `${col.DataQaId}-row-${index}`,
                                                                options:
                                                                  _vm.getParamList(
                                                                    col,
                                                                    entry
                                                                  ),
                                                                label:
                                                                  "ValueDesc",
                                                                "track-by":
                                                                  "ValueCode",
                                                                "emit-value":
                                                                  "",
                                                                readonly:
                                                                  _vm.shouldBeReadOnly(
                                                                    col
                                                                  ),
                                                              },
                                                              model: {
                                                                value:
                                                                  entry[
                                                                    col
                                                                      .InternalField
                                                                  ],
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      entry,
                                                                      col.InternalField,
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "entry[col.InternalField]",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        col.FieldControlType ===
                                                        "checkbox"
                                                          ? _c("pix-checkbox", {
                                                              attrs: {
                                                                id: `gtable-${_vm.tableId}-${index}-${indexCol}-checkbox`,
                                                                "data-qa-id": `${col.DataQaId}-row-${index}`,
                                                                readonly:
                                                                  _vm.shouldBeReadOnly(
                                                                    col
                                                                  ),
                                                              },
                                                              model: {
                                                                value:
                                                                  entry[
                                                                    col
                                                                      .InternalField
                                                                  ],
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      entry,
                                                                      col.InternalField,
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "entry[col.InternalField]",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        col.FieldControlType ===
                                                        "input"
                                                          ? _c("pix-input", {
                                                              attrs: {
                                                                id: `gtable-${_vm.tableId}-${index}-${indexCol}-input`,
                                                                "data-qa-id": `${col.DataQaId}-row-${index}`,
                                                                type: col.FieldDataType,
                                                                min: -2147483648,
                                                                max: 2147483647,
                                                                readonly:
                                                                  _vm.shouldBeReadOnly(
                                                                    col
                                                                  ),
                                                                "input-format":
                                                                  col.Format,
                                                              },
                                                              on: {
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleTableInput(
                                                                      entry
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  entry[
                                                                    col
                                                                      .InternalField
                                                                  ],
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      entry,
                                                                      col.InternalField,
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "entry[col.InternalField]",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        col.FieldControlType ===
                                                          "datepicker" &&
                                                        _vm.userDateFormat
                                                          ? _c(
                                                              "pix-datepicker",
                                                              {
                                                                attrs: {
                                                                  id: `gtable-${_vm.tableId}-${index}-${indexCol}-datepicker`,
                                                                  "data-qa-id": `${col.DataQaId}-row-${index}`,
                                                                  format:
                                                                    _vm.userDateFormat,
                                                                  fieldName: `gtable-${_vm.tableId}-${index}-${indexCol}-datepicker`,
                                                                  readonly:
                                                                    _vm.shouldBeReadOnly(
                                                                      col
                                                                    ),
                                                                },
                                                                model: {
                                                                  value:
                                                                    entry[
                                                                      col
                                                                        .InternalField
                                                                    ],
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        entry,
                                                                        col.InternalField,
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "entry[col.InternalField]",
                                                                },
                                                              }
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    : [
                                                        col.ParamId === null &&
                                                        col.CellType === null
                                                          ? _c("div", [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm.fnGetDataValue(
                                                                      entry,
                                                                      col
                                                                    )
                                                                  ) +
                                                                  "\n                      "
                                                              ),
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        col.ParamId !== null &&
                                                        (!col.conditionalValues ||
                                                          col.conditionalValues
                                                            .length === 0)
                                                          ? _c("div", [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm.formatValueCodParam(
                                                                      _vm.fnGetDataValue(
                                                                        entry,
                                                                        col
                                                                      ),
                                                                      col.ParamListValues
                                                                    )
                                                                  ) +
                                                                  "\n                      "
                                                              ),
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        col.CellType ===
                                                        "StringType"
                                                          ? _c(
                                                              "cell-dt-string-type-component",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    _vm.fnGetDataValue(
                                                                      entry,
                                                                      col
                                                                    ),
                                                                  index: index,
                                                                  readTransform:
                                                                    col.ReadTransform,
                                                                  conditionsDict:
                                                                    col.conditionalValues,
                                                                },
                                                              }
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        col.CellType ===
                                                        "DateType"
                                                          ? _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getDateWithoutTimeZoneInUserFormat(
                                                                    _vm.fnGetDataValue(
                                                                      entry,
                                                                      col
                                                                    )
                                                                  )
                                                                )
                                                              ),
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        col.CellType ===
                                                        "AutocompleteType"
                                                          ? _c(
                                                              "cell-dt-typeahead-type-component",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    _vm.fnGetDataValue(
                                                                      entry,
                                                                      col
                                                                    ),
                                                                  config: col,
                                                                },
                                                              }
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        col.CellType ===
                                                        "NumberType"
                                                          ? _c(
                                                              "cell-dt-number-type-component",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    _vm.fnGetDataValue(
                                                                      entry,
                                                                      col
                                                                    ),
                                                                  outcomes:
                                                                    col.Values,
                                                                  format:
                                                                    col.Format,
                                                                  readTransform:
                                                                    col.ReadTransform,
                                                                  conditionsDict:
                                                                    col.conditionalValues,
                                                                  index: index,
                                                                  currency:
                                                                    _vm.getCurrencyParam(
                                                                      index
                                                                    ),
                                                                  area: _vm.getAreaParam(
                                                                    index
                                                                  ),
                                                                  frequency:
                                                                    _vm.getFreqParam(
                                                                      index
                                                                    ),
                                                                },
                                                              }
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        col.CellType ===
                                                        "BooleanType"
                                                          ? _c(
                                                              "cell-dt-boolean-type-component",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    _vm.fnGetDataValue(
                                                                      entry,
                                                                      col
                                                                    ),
                                                                  outcomes:
                                                                    col.Values,
                                                                },
                                                              }
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        col.CellType ===
                                                        "LinkType"
                                                          ? _c(
                                                              "cell-dt-link-type-component",
                                                              {
                                                                staticClass:
                                                                  "cell-linktype",
                                                                class: `cell-linktype-${col.InternalField}`,
                                                                attrs: {
                                                                  col: col,
                                                                  value:
                                                                    _vm.fnGetDataValue(
                                                                      entry,
                                                                      col
                                                                    ),
                                                                  index: index,
                                                                  conditionsDict:
                                                                    col.conditionalValues,
                                                                  readTransform:
                                                                    col.ReadTransform,
                                                                  format:
                                                                    col.Format,
                                                                  currency:
                                                                    _vm.getCurrencyParam(
                                                                      index
                                                                    ),
                                                                  area: _vm.getAreaParam(
                                                                    index
                                                                  ),
                                                                  frequency:
                                                                    _vm.getFreqParam(
                                                                      index
                                                                    ),
                                                                  precedent:
                                                                    _vm.getPrecedentNum(
                                                                      index
                                                                    ),
                                                                  disabled:
                                                                    _vm.allTheColumnsAreConfidential &&
                                                                    (_vm.shouldDisableActions ||
                                                                      _vm.shouldBlurConfidentialFields),
                                                                },
                                                                on: {
                                                                  "btn-click":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.fnCallBack(
                                                                        $event,
                                                                        col,
                                                                        entry
                                                                      )
                                                                    },
                                                                },
                                                              }
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        col.CellType ===
                                                        "RouterType"
                                                          ? _c("router-cell", {
                                                              attrs: {
                                                                value:
                                                                  _vm.fnGetDataValue(
                                                                    entry,
                                                                    col
                                                                  ),
                                                                "config-column":
                                                                  col,
                                                                "data-row":
                                                                  entry,
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        col.CellType ===
                                                        "PreType"
                                                          ? _c("pre", {
                                                              domProps: {
                                                                textContent:
                                                                  _vm._s(
                                                                    _vm.fnGetDataValue(
                                                                      entry,
                                                                      col
                                                                    )
                                                                  ),
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        col.CellType ===
                                                        "ToggleType"
                                                          ? _c(
                                                              "cell-dt-toggle-type-component",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    _vm.fnGetDataValue(
                                                                      entry,
                                                                      col
                                                                    ),
                                                                  index: index,
                                                                  toggleKey:
                                                                    _vm.keyDate,
                                                                  color:
                                                                    "var(--jll-red-400)",
                                                                },
                                                                on: {
                                                                  "btn-click":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.fnCallBack(
                                                                        $event,
                                                                        col,
                                                                        entry
                                                                      )
                                                                    },
                                                                },
                                                              }
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                ],
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        }),
                        _vm._v(" "),
                        _vm.hasTotalsRow &&
                        !!_vm.lstOfDatRows &&
                        !!_vm.lstOfDatRows.length
                          ? _c(
                              "tr",
                              { staticClass: "pix-generic-table__total-row" },
                              _vm._l(
                                _vm.columnsToDisplay,
                                function (column, columnIndex) {
                                  return _c(
                                    "td",
                                    {
                                      key: columnIndex,
                                      staticClass:
                                        "pix-generic-table__total-cell",
                                    },
                                    [
                                      _c("pix-input", {
                                        attrs: {
                                          type: column.FieldDataType,
                                          readonly: "",
                                          "input-format": column.Format,
                                        },
                                        model: {
                                          value:
                                            _vm.totalsRowData[
                                              column.InternalField
                                            ],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.totalsRowData,
                                              column.InternalField,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "totalsRowData[column.InternalField]",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasSubtable && !_vm.entry.collapsed
                          ? _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass:
                                    "subtableFontSize subtableBackground",
                                  attrs: {
                                    id: `gtable-${_vm.tableId}-${_vm.index}-subtable`,
                                    "data-uid": `gtable-${_vm.tableId}-${_vm.index}-subtable`,
                                    colspan: 2 * _vm.columnsToDisplay.length,
                                  },
                                },
                                [
                                  _c(
                                    "keep-alive",
                                    [
                                      _c(_vm.subtableComponent.component, {
                                        tag: "component",
                                        attrs: { id: _vm.entry[_vm.keyField] },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._t("pagination"),
                      ],
                      2
                    ),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              !_vm.lstOfDatRows || _vm.lstOfDatRows.length === 0
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "alert alert-warning text-center",
                        attrs: { role: "alert" },
                      },
                      [_vm._v("No Data")]
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "modalColumns",
                staticClass: "modal fade",
                attrs: {
                  id: _vm.idcolumnListModal,
                  "data-backdrop": "static",
                  tabindex: "-1",
                  role: "dialog",
                  "aria-hidden": "true",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "modal-dialog", attrs: { role: "document" } },
                  [
                    _c("div", { staticClass: "modal-content" }, [
                      _c("div", { staticClass: "modal-header" }, [
                        _c("h5", { staticClass: "modal-title" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "components.genericTable.columnList.modalTitle"
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "close",
                            attrs: {
                              type: "button",
                              "data-dismiss": "modal",
                              "aria-label": "Close",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.closeModal()
                              },
                            },
                          },
                          [
                            _c("span", { attrs: { "aria-hidden": "true" } }, [
                              _vm._v("×"),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-body p-0" }, [
                        _c(
                          "div",
                          { staticClass: "table-responsive text-nowrap" },
                          [
                            _c(
                              "table",
                              {
                                staticClass:
                                  "table table-sm table-condensed table-hover table-bordered small m-0",
                              },
                              [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", { staticClass: "text-light" }, [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t(
                                              "components.genericTable.columnList.index"
                                            )
                                          ) +
                                          "\n                    "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-light",
                                        attrs: { width: "100%" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "components.genericTable.columnList.column"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("th", { staticClass: "text-center" }, [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t(
                                              "components.genericTable.columnList.isVisible"
                                            )
                                          ) +
                                          "\n                    "
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "draggable",
                                  {
                                    attrs: { tag: "tbody", handle: ".handle" },
                                    model: {
                                      value: _vm.modalColumns,
                                      callback: function ($$v) {
                                        _vm.modalColumns = $$v
                                      },
                                      expression: "modalColumns",
                                    },
                                  },
                                  _vm._l(
                                    _vm.modalColumns,
                                    function (column, index) {
                                      return _c(
                                        "tr",
                                        { key: column.gtOrder },
                                        [
                                          _vm.fnEvalCondition(
                                            column.Conditions
                                          ) && _vm.fnIsVisible(column)
                                            ? [
                                                _c(
                                                  "td",
                                                  {
                                                    class: {
                                                      "text-muted":
                                                        column.gtShown ===
                                                        false,
                                                    },
                                                  },
                                                  [
                                                    _c("div", {}, [
                                                      _c("span", {
                                                        staticClass:
                                                          "mdi mdi-menu grabbable handle",
                                                      }),
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(index) +
                                                          "\n                        "
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    class: {
                                                      "text-muted":
                                                        column.gtShown ===
                                                        false,
                                                    },
                                                    attrs: { width: "100%" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(column.Label) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    class: {
                                                      "text-center wPointer":
                                                        column.gtShown === true,
                                                      "text-center table-secondary wPointer":
                                                        column.gtShown ===
                                                        false,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            column.gtShown =
                                                              !column.gtShown
                                                          },
                                                        },
                                                      },
                                                      [
                                                        !column.gtShown
                                                          ? _c("span", {
                                                              staticClass:
                                                                "mdi mdi-checkbox-blank-outline",
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        column.gtShown
                                                          ? _c("span", {
                                                              staticClass:
                                                                "mdi mdi-checkbox-marked-outline",
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-footer" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-warning",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.fnResetTableConf()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("common.lblReset")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-primary",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.fnSaveTableConf()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("common.lblSave")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button", "data-dismiss": "modal" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.closeModal()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("common.lblClose")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }